import PaymentRequests from './PaymentRequests'
export default PaymentRequests
